import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section id="garanzia" className="w-full bg-green-50 py-20 px-4 sm:px-6 lg:px-8" data-id="element-78">
      <div className="max-w-3xl mx-auto text-center" data-id="element-79">
        <ShieldCheckIcon className="w-20 h-20 mx-auto mb-6 text-green-600" data-id="element-80" />
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-81">
          Provalo senza rischi
        </h2>
        <p className="text-xl sm:text-2xl text-gray-700" data-id="element-82">
          Se non senti valore entro 7 giorni, rimborso 100%. La tua fiducia è la
          nostra priorità.
        </p>
      </div>
    </section>;
}